import React from 'react';
import { Link } from 'react-router-dom';
import * as Scroll from 'react-scroll';
import { animateScroll as scroll } from 'react-scroll';
import { heights, spacing, colors, widths, fonts } from './../../styles/theme.json';
import SocialIcons from './../SocialIcons';

const scrollToTop = () => {
  scroll.scrollToTop({
    duration: 350
  });
};

const MobileFooter = (props) => (
  <div className={'inner-footer'}>
    <ul className={'footer-items'}>
      <li className={'footer-item'}>
        <SocialIcons/>
      </li>
      <li className={'footer-item'}>
        <Link className={'contact external-link'} to={'/contact'}>Contact</Link>
      </li>
      <li className={'footer-item'}>
        <Link className={'external-link'} to={'/terms'}><span>{'Terms'}</span></Link>
      </li>
      <li className={'footer-item'}>
        <div className={'top external-link btt'} onClick={scrollToTop}>Back to Top</div>
      </li>
      <li className={'footer-item'}>
        <div className={'copyright'} dangerouslySetInnerHTML={{__html:'&#169; Bruce Weber'}}/>
      </li>
    </ul>
    <style jsx>{`
      .inner-footer {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        flex-direction: row;
        padding: 3rem;
      }
      .footer-items {
        display: flex;
        flex-direction: column;
        list-style: none;
      }
      .footer-item {
        display: flex;
        width: 100%;
        justify-content: center;
        margin-bottom: 1.5rem;
      }
      .footer-item:first-child {
        margin-bottom: 3rem;
      }
      .footer-item:last-child {
        margin-top: 1.5rem;
        margin-bottom: 0;
      }
      .copyright {
        font-size: 1.2rem;
        font-family: ${fonts.mallory};
        text-transform: uppercase;
        font-weight: 700;
      }
      .top,
      .terms {
        color: ${colors.black};
        display: block;
        line-height: 1.1;
      }
      .top,
      .contact {
        color: ${colors.black};
        border-bottom: 1px solid ${colors.black};
      }
    `}</style>
  </div>
);

export default MobileFooter;



// WEBPACK FOOTER //
// ./src/components/footer/MobileFooter.js